import React from 'react'

export const connecticutSetupVars = {
  siteId: 'connecticut',
  pathPrefix: '/ct',
  menuHeader: "Discover Connecticut's Solution for:",
  appUrl: 'https://ct.headed2.com',
  logoImg: '/images/assets/connecticut/horizontal/dark.svg',
  headerTitle: `The Connecticut CareerExplorer is a system designed for Connecticut`
}
